module.exports = "/lucky-balls/img/infobox/info_Box_025.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_025.png
// module id = 1090
// module chunks = 0